const firebaseConfig = {
    apiKey: "AIzaSyBR8g08H9h7rei9hZt2J3xT8DuUExIzrII",
    authDomain: "yamashiro-hotspring.firebaseapp.com",
    projectId: "yamashiro-hotspring",
    storageBucket: "yamashiro-hotspring.appspot.com",
    messagingSenderId: "225591267693",
    appId: "1:225591267693:web:cec201429aed337e6fca64"
  };

  export default firebaseConfig;